<template>
    <!-- <div class="ChannelSelected">
        <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
                {{ language }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div> -->
    <div class="langBtn">
        <span @click="handleLang">{{ flag ? '切换中文' : 'lang English' }}</span>
    </div>
</template>
<script>
import { commonServer } from '@/API/home';

export default {
    name: "ChannelSelected",
    data() {
        return {
            // language: ""
            flag: false
        };
    },
    methods: {
        // 根据下拉框的中被选中的值切换语言
        // handleCommand(command) {
        //     if (command === "zh") {
        //         this.lang = "中文";
        //         document.title = "营销管理系统";
        //     } else {
        //         this.lang = "English";
        //         document.title = "Marketing  Management System";
        //     }
        //     this.$i18n.locale = command;
        //     window.localStorage.setItem("lang", command);
        //     window.location.reload();
        // }
        // 点击切换语言
        handleLang() {
            this.flag = !this.flag;
            let command = "zh-CN";
            if (this.flag) command = "en-US";
            document.title = this.flag ? "Marketing  Management System" : "营销管理系统";
            window.localStorage.setItem("lang", command);
            commonServer.updateUserLang().then(res => {
                if (res.status === '200') {
                    window.location.reload();
                }
            })
        }
    },
    created() {
        this.flag = this.$i18n.locale !== "zh-CN";
        document.title = this.$i18n.locale === "zh-CN" ? "营销管理系统" : "Marketing  Management System";
    }
};
</script>
<style lang="scss">
// .ChannelSelected {
//     .el-dropdown-link {
//         &:hover {
//             cursor: pointer;
//         }
//     }
// }

.langBtn {
    &:hover {
        cursor: pointer;
    }
}
</style>
